import { render, staticRenderFns } from "./TenancyStatement.vue?vue&type=template&id=fc34074e&scoped=true"
import script from "./TenancyStatement.vue?vue&type=script&lang=js"
export * from "./TenancyStatement.vue?vue&type=script&lang=js"
import style0 from "./TenancyStatement.vue?vue&type=style&index=0&id=fc34074e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc34074e",
  null
  
)

export default component.exports